import type {Integer, Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {z as zod} from "zod";
import {integerZodValidator, iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

/** Matches tuffex InventorySource UUIDs for migration compatibility. */
export enum ProductInventoryItemSource {
    throughApi = "f3a8b2c1-4d5e-6f78-9012-3a4b5c6d7e8f",
    throughProducts = "e2b7a1d0-3c4d-5e67-8901-2a3b4c5d6e7f",
    throughCsvSync = "d1c6b0a9-2b3c-4d56-7890-1a2b3c4d5e6f",
}

export type ProductInventoryEnriched = {
    id: Uuid;
    productCatalogueId: Uuid;
    sku: string;
    inventory: Integer;
    ouId: Uuid;
    plantId: string | null;
    storageLocation: string | null;
    categoryId: Uuid | null;
    categoryName: string | null;
    brandId: Uuid | null;
    brandName: string | null;
    typeId: Uuid | null;
    typeName: string | null;
    manufacturerName: string | null;
    lastInventoryItemUpdatedAt: Iso8601DateTime | null;
    createdAt: Iso8601DateTime;
    updatedAt: Iso8601DateTime;
};

export const productInventoryEnrichedValidator: zod.ZodType<ProductInventoryEnriched> = zod.object({
    id: uuidZodValidator,
    productCatalogueId: uuidZodValidator,
    sku: zod.string(),
    inventory: integerZodValidator,
    ouId: uuidZodValidator,
    plantId: zod.string().nullable(),
    storageLocation: zod.string().nullable(),
    categoryId: uuidZodValidator.nullable(),
    categoryName: zod.string().nullable(),
    brandId: uuidZodValidator.nullable(),
    brandName: zod.string().nullable(),
    typeId: uuidZodValidator.nullable(),
    typeName: zod.string().nullable(),
    manufacturerName: zod.string().nullable(),
    lastInventoryItemUpdatedAt: iso8601DateTimeZodValidator.nullable(),
    createdAt: iso8601DateTimeZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
});

export type ProductInventoryItemLog = {
    id: Uuid;
    productCatalogueId: Uuid;
    sku: string;
    plantId: string | null;
    availableInventory: Integer;
    storageLocation: string | null;
    createdAt: Iso8601DateTime;
    updatedAt: Iso8601DateTime;
    source: ProductInventoryItemSource;
};

export const productInventoryItemLogValidator: zod.ZodType<ProductInventoryItemLog> = zod.object({
    id: uuidZodValidator,
    productCatalogueId: uuidZodValidator,
    sku: zod.string(),
    plantId: zod.string().nullable(),
    availableInventory: integerZodValidator,
    storageLocation: zod.string().nullable(),
    createdAt: iso8601DateTimeZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
    source: zod.enum(ProductInventoryItemSource),
});
